import { useState, useEffect } from 'react';
import useDataBean from '../../../../core/services/dataBean/useDataBean';
import { _StrategicObjetive } from '../../../../core/services/dataBean/EntityCatalog';

interface Props {
    macroProcess?: number;
    subProcess?: number;
    idSelector: number;
    onChange: any;
    label?: string;
}

export const StrategicObjectiveEditor = ({ idSelector, macroProcess, onChange, label, subProcess }: Props) => {

    const strategicObjective = useDataBean(_StrategicObjetive)
    const [lista, setLista] = useState<any>([])
    const [id, setID] = useState(null);

    useEffect(() => {
        if (idSelector) {
            setID(idSelector)
        }
    }, [])

    useEffect(() => {
        getLista();
    }, [macroProcess, subProcess])

    useEffect(() => {
        onChange(id);
    }, [id])

    const setValue = (e: any) => {
        setID(parseInt(e));
        onChange(id);
    }

    const getLista = () => {
        strategicObjective.instance.getStrategicObjectiveCatalog(macroProcess ?? null, subProcess ?? null).then(
            (resp) => {
                setLista(resp)
            }
        )
    }

    return (
        <>
            <label>{label ?? "Objetivo Estrategico"}</label>
            <select className="form-select" value={id} onChange={(e) => { setValue(e.target.value) }}>
                <option value={null}>...</option>
                {lista &&
                    lista.map((item: any, index: number) => {
                        return (
                            <option key={index} value={item.DataBeanProperties.IDStrategicObjective} >{item.DataBeanProperties.Name}</option>
                        )
                    })
                }
            </select>
        </>
    )
}